import {DEF_FIELD} from './constants'
export default (type)=>{
    return {
      type: type.nameC,
      description: type.description,
      ...DEF_FIELD
    }
}
